export default __webpack_public_path__ + "static/media/productValues4.71522689.svg";